// extracted by mini-css-extract-plugin
export default {"RadioQuestion":"RadioQuestion_RadioQuestion__ddM7h","SingleRadio":"RadioQuestion_SingleRadio__U893r"};